import { useNuxtApp } from "#imports";
import { inView } from "motion";
import { onMounted, ref, watch } from "vue";
export function useElementInView(element, sliceRef) {
  const { $voix } = useNuxtApp();
  const elementInView = ref(false);
  const countedTheView = ref(false);
  const viewInitialized = ref(false);
  function initializeView() {
    if (viewInitialized.value)
      return;
    const el = sliceRef.value?.$el;
    if (!el || !(el instanceof HTMLElement) || !el.tagName)
      return;
    viewInitialized.value = true;
    inView(el, () => {
      if (!countedTheView.value)
        $voix.eventBus.emit("voix:slice:viewed", element);
      elementInView.value = true;
      countedTheView.value = true;
      return () => {
        elementInView.value = false;
      };
    });
  }
  onMounted(() => {
    initializeView();
  });
  watch(
    () => sliceRef.value,
    () => {
      initializeView();
    }
  );
  return { elementInView };
}
